<template>
  <div class="company-wall-questions-skeleton">
    <div
      v-for="item in 5"
      :key="item"
      class="company-wall-questions-skeleton__item"
    >
      <PSkeleton width="80%" />
      <PSkeleton size="1rem" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { PSkeleton } from "@solvari/components";
</script>

<style scoped lang="postcss">
.company-wall-questions-skeleton {
  @apply flex w-full flex-col gap-4;

  &__item {
    @apply flex justify-between border-b p-4;
  }
}
</style>
